<template>
  <b-modal
    hide-footer
    centered
    ref="add-newdespesa-modal"
    size="lg"
    id="add-newdespesa-modal"
    title="Adicionar Despesa"
    >
       <!-- <template #modal-header>
        <div class="d-flex justify-content-center w-100">
            <p id="title-modal">ADICIONAR DESPESA</p>
            <div @click="closeModal" id="closed-modal">X</div>
        </div>
       </template> -->
       <div id="body-modal">
          <label class="label-form">*Despesas</label>
          <select v-model="idDespesaItem" class="form-control">
              <option value="">Selecione</option>
              <option v-for="data in dataTypes" :key="data.id" :value="data.id">{{data.nome}}</option>
          </select>
          <div class="d-flex">
              <div class="col-md-4">
                  <label class="label-form"  for="txtGroupsName"><small class="text-danger">*</small> Quantidade:</label>
                  <div class="input-group">
                      <span class="input-group-addon"><i class="fas fa-calculator"></i></span>
                      <money class="form-control form-control-10 text-right"
                          v-bind="integerFormat"
                          placeholder="0"
                          @blur.native="calcularTotal"
                          v-model="quantidade"
                          :size="form.quantidade.maxlength"
                          :state="form.quantidade.state"
                          :required="form.quantidade.required"/>
                  </div>
              </div>
              <div class="col-md-4">
                  <label class="label-form"><small class="text-danger">*</small> Valor:</label>
                  <div class="input-group">
                      <span class="input-group-addon"><i class="fas fa-dollar-sign"></i></span>
                      <money class="form-control form-control-10 text-right"
                      v-bind="moneyFormat"
                      placeholder="R$ 0,00"
                      @blur.native="calcularTotal"
                      prefix="R$ "
                      v-model="valorUnitario"
                      :size="form.valorUnitario.maxlength"
                      :required="form.valorUnitario.required"
                      :state="form.valorUnitario.state"/>
                  </div>
              </div>
              <div class="col-md-4">
                  <label class="label-form"><small class="text-danger">*</small>Valor Total:</label>
                  <div class="input-group">
                      <span class="input-group-addon"><i class="fas fa-dollar-sign"></i></span>
                      <money class="form-control form-control-10 text-right text-bold"
                      v-bind="moneyFormat"
                      placeholder="R$ 0,00"
                      prefix="R$ "
                      v-model="total"
                      :size="form.total.maxlength"
                      :required="form.total.required"
                      :state="form.total.state"
                      :disabled="true"/>
                  </div>
              </div>
          </div>
          <label class="label-form">Observação:</label>
          <div class="d-flex justify-content-center mt-2">
              <textarea class="form-control" v-model="observacao"></textarea>
          </div>
            <div class="d-flex justify-content-center mt-3">
                  <button @click="closeModal" class="btn-cancel mx-2">CANCELAR</button>
                  <button @click="save" class="btn-add mx-2">ADICIONAR</button>
              </div>
       </div>
    </b-modal>
</template>

<script>
import ModalNewDespesas from './ModalNewDespesas'
export default ModalNewDespesas
</script>

<style scoped>
 #title-modal{
    font-size: 35px;
    font-weight: bold;
    color: white;
 }
 #closed-modal{
    position: absolute;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    top: 10px;
    right: 10px;
    font-weight: bold;
    font-size: 18px;
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    color: red;
    background: white;
 }
 .label-form{
  margin-top: 25px;
  margin-bottom: 0;
 }
 .btn-cancel{
    width: 250px;
    height: 50px;
    background: #ECEFF1;
    font-weight: bold;
    border-radius: 7px;
    border: none;
 }
 .btn-add{
    width: 250px;
    height: 50px;
    background: #008144;
    border-radius: 7px;
    color: white;
    font-weight: bold;
    border: none;
 }
  .btn-add:hover{
    background: #015a31;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/ModalNewDespesas/ModalNewDespesas.vue